import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        display: "flex",
        alignContent: "center"
    },
    circle: {
        borderRadius: "50%",
        border: (props) => `2px solid ${props.theme.primaryColor}`
    }
});


export default function BrAvatar({ user, theme, avatarStyles, label, className, goToProfile = true }) {
    const history = useHistory();
    const classes = useStyles({ theme });
    
    const handleClick = () => {
        if (!goToProfile) return;
        if (user?.id) {
            history.push(`/user/${user.id}`);
        }
    };
    
    return (
        <div className={`${classes.root} ${className}`} style={avatarStyles}>
            <Avatar
                onClick={handleClick}
                alt={user?.name[0] || "User Avatar"}
                className={classes.circle}
                style={avatarStyles}
                src={(() => {
                    // Use the user's selected avatar if available
                    if (user?.avatar?.url) {
                        return `/avatars/${user.avatar.url}`;
                    }
                    
                    // Fallback to default gender-based avatars if no avatar is selected
                    const fallbackAvatar = user?.gender === "F" ? "/avatars/001-girl-1.png" : "/avatars/019-boy.png";
                    console.log('Avatar: Using fallback avatar for user', user.id, ':', fallbackAvatar, '(no selected avatar - avatar_id:', user?.avatar_id, ', avatar_object:', user?.avatar, ')');
                    return fallbackAvatar;
                })()}
            />
            {label && (
                <span
                    style={{
                        whiteSpace: "nowrap",
                        paddingTop: "10px",
                        fontWeight: "bold",
                        marginLeft: "8px"
                    }}
                >
                    {(() => {
                        // Check if this is a parent user who has selected a child to impersonate
                        // If so, display the selected child's name instead of "parent"
                        if (label.toLowerCase() === "parent") {
                            try {
                                const selectedChildSettings = JSON.parse(
                                    window.localStorage.getItem('SELECTED_CHILD_SETTINGS') || '{}'
                                );
                                // Use the selected child's name if available, otherwise fall back to the original label
                                const childName = selectedChildSettings?.name;
                                if (childName) {
                                    return childName[0].toUpperCase() + childName.slice(1);
                                }
                            } catch (error) {
                                console.warn('Avatar: Error parsing selected child settings:', error);
                            }
                        }
                        // Default behavior: use the original label
                        return label[0].toUpperCase() + label.slice(1);
                    })()}
                </span>
            )}
        </div>
    );
};